import { routes } from './routes';
import {MenuItem} from '../../../../lib/phinxapp/profiles/types';
import { Customers } from '../../../../application/screens/Private';

export const customersMenu: MenuItem = {
    key: 'customersMenu',
    basePath: '/customers',
    target:{path: '/',component: Customers},
    enabled: true,
    icon: 'List',
    text: 'customers',
    children: routes,
    default: true,
};
